import { LAYOUT_SET_TOPBAR_TITLE } from 'store/modules/layout'

export default (titleParts = []) => {
  return {
    mounted() {
      this.refreshTitle()
    },
    methods: {
      refreshTitle() {
        this.$store.commit({
          type: LAYOUT_SET_TOPBAR_TITLE,
          title: this.currentTitle
        })
        const lastTitle = this.currentTitle[this.currentTitle.length - 1]
        const titleText = lastTitle instanceof Object ? lastTitle.name : lastTitle
        document.title = (titleText || '') + (titleText ? ' | CMS' : 'CMS')
      }
    },
    computed: {
      currentTitle() {
        return titleParts
      }
    },
    watch: {
      currentTitle() {
        this.refreshTitle()
      }
    }
  }
}
